// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-modal-container',
    computed: {
        modalWindows: function () {
            return this.$appHost.store.get("windows").modalWindows;
        },
    },
});
// #endregion
